export default __webpack_public_path__ + "static/media/c1.b61fa279.png";